import {useRef, useState, useEffect} from "react";
import "./ScrollBanner.css";
import ApiV0 from "../services/ApiV0";
import CUtils from "../services/CUtils"; // Import du fichier CSS

const imgSample = "https://i.etsystatic.com/10875986/r/il/25d697/6667824107/il_fullxfull.6667824107_djk1.jpg";

const sectionToItem = section => {
    const lang = ApiV0.getLang();
    const isEn = lang === 'en';
    const id = section.shop_section_id;
    const logo = section.images?.length > 0 ? section.images[0]?.url_fullxfull : imgSample;
    const title = CUtils._(isEn && section.en_title ? section.en_title : section.title);
    const description = CUtils._(isEn && section.en_description ? section.en_description : section.description);
    const slug = isEn && section.en_slug ? section.en_slug : section.slug;
    const href = `/listing/${slug}`;
    return {id, href, logo, title, description};
};
const sectionsToItem = sections => sections.map(s => sectionToItem(s));

export default function ScrollBanner(props) {
    const {sections} = props;
    const bannerRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(true);
    const [isDragging, setIsDragging] = useState(false);
    const startX = useRef(0);
    const scrollLeft = useRef(0);
    const velocity = useRef(0);
    const animationFrame = useRef(null);

    useEffect(() => {
        updateScrollButtons();
    }, []);

    const updateScrollButtons = () => {
        if (!bannerRef.current) return;
        const container = bannerRef.current;
        setCanScrollLeft(container.scrollLeft > 0);
        setCanScrollRight(container.scrollLeft < container.scrollWidth - container.clientWidth);
    };

    const startDrag = (e) => {
        e.preventDefault(); // Empêche la sélection accidentelle du texte
        setIsDragging(true);
        startX.current = e.pageX || e.touches[0].pageX;
        scrollLeft.current = bannerRef.current.scrollLeft;
        velocity.current = 0;
        cancelAnimationFrame(animationFrame.current);
    };

    const onDrag = (e) => {
        if (!isDragging || !bannerRef.current) return;
        const x = e.pageX || e.touches[0].pageX;
        const delta = startX.current - x > 0 ? 400 : -400;
        bannerRef.current.scrollLeft = scrollLeft.current + delta;
    };

    const endDrag = () => {
        setIsDragging(false);
        setTimeout(updateScrollButtons, 100);
    };

    const scroll = (direction) => {
        if (!bannerRef.current) return;
        const container = bannerRef.current;
        container.scrollBy({left: direction === "left" ? -400 : 400, behavior: "smooth"});
        setTimeout(updateScrollButtons, 100);
    };

    const bannerItems = sections ? sectionsToItem(sections) : [];
    return (
        <div className="scroll-banner-container">
            {canScrollLeft && (
                <button className="scroll-button left"
                        onMouseEnter={() => scroll("left")}
                        onClick={() => scroll("left")}>◀</button>
            )}

            {/* Bandeau avec scroll horizontal */}
            <div className="scroll-banner" ref={bannerRef}
                 onMouseDown={startDrag}
                 onMouseMove={onDrag}
                 onMouseUp={endDrag}
                 onMouseLeave={endDrag}
                 onTouchStart={startDrag}
                 onTouchMove={onDrag}
                 onTouchEnd={endDrag}
            >
                {bannerItems.map((item) => (
                    <div key={item.id} className="banner-item">
                        <a href={item.href}><img src={item.logo} alt={item.title} className="item-logo"/></a>
                        <h3 className="item-title">{item.title}</h3>
                        <p className="item-description hidden">{item.description}</p>{/* description == keywords*/}
                    </div>
                ))}
            </div>

            {canScrollRight && (
                <button className="scroll-button right"
                        onMouseEnter={() => scroll("right")}
                        onClick={() => scroll("right")}>▶</button>
            )}
        </div>
    );
}
